import React, { useMemo } from 'react';
import useLinkProps from '../../hooks/useLinkProps';
import useLinkStyles from './useLinkStyles';
const withA = (Component) => React.forwardRef((props, ref) => {
    const { children, to, inverted = false, small = false, styles } = props;
    const { isHovered, isFocused, ...rest } = useLinkProps(to, children);
    const style = useLinkStyles({ isHovered, isFocused, inverted, small, styles });
    const processedProps = useMemo(() => ({
        ...rest,
        style
    }), [rest, style]);
    return 'to' in processedProps ? (React.createElement(Component, { ...processedProps, ref: ref })) : (React.createElement("a", { ...processedProps }, rest.children));
});
export default withA;
//# sourceMappingURL=withA.js.map